import {Pipe, PipeTransform} from "@angular/core";

@Pipe({
  name: 'address',
  standalone: true
})
export default class AddressPipe implements PipeTransform {
  public transform(addressObject: {
    street: string,
    housenumber: string,
    housenumberext: string,
    zipcode: string,
    city: string
  } | null): string {

    if (!addressObject) {
      return "";
    }

    const separator: string = ', ';
    const line1: string = ((addressObject.street ?? '') + ' ' + (addressObject.housenumber ?? '') + (addressObject.housenumberext ?? '')).toString().trim();
    const line2: string = ((addressObject.zipcode ?? '') + ' ' + (addressObject.city ?? '')).toString().trim();

    return line1 + (line1.trim().length > 0 ? separator : '') + line2;
  }
}
